export const QueryKey = {
	content: 'content',
	assets: 'assets',

	products: 'products',

	accessoryCategories: 'accessory-categories',
	accessories: 'accessories',
	accessoryNameOverrides: 'accessory-name-overrides',
	creatorAccessories: 'creator-accessories',

	attributes: 'attributes',
	attributeValues: 'attribute-values',

	productTypes: 'product-types',
	productTypeVariations: 'product-type-variations',

	doors: 'doors',

	offers: 'offers',
} as const;

export type QueryKey = (typeof QueryKey)[keyof typeof QueryKey];
